import React, { useState, useContext, useEffect, Fragment } from "react";
import { useNavigate, Link } from "react-router-dom";
import { usePendingUpdates } from "../../Libs/useFetcPendingUpdateVOwner";
import PendingUpdateCard from "../pendUpdatesCard";
import useStatutoryDocs from "../../Libs/useFetchStadoc";
import ViewOtherLicenses from "../../view/viewotherlicenses_v";
import ViewOtherDocs from "../../view/viewotherdocs";
import Skeleton from "react-loading-skeleton";
import { CiFileOn } from "react-icons/ci";
import { ReactComponent as Markicon } from "../../../Asset/circle.svg";
import { AuthContext } from "../../../Context/AuthContext";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from "react-toastify";
import "./updates.css";

const UpdatesVesselOwner = () => {
  const {
    data: statutoryDoc,
    error: staError,
    isLoading: staLoading,
  } = useStatutoryDocs();
  const { profileData } = useContext(AuthContext);
  const navigate = useNavigate();

  const { data, error, isLoading } = usePendingUpdates();
  const [isAllDocs, setAllDoc] = useState(true);
  const [isAllPendingUpdate, setAllPendingUpdate] = useState(false);
  const [activeSection, setActiveSection] = useState("updates");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  const activeStyle = {
    border: "1px solid #0963EB",
  };

  const activeSwitchLineStyle = { borderBottom: "3px solid #0754c8" };



  useEffect(() => {
    if (profileData) {
      const profileStepStatus = profileData?.createdProfileStepStatus?.status;
      let navigateTo = "";
      let message = "Redirecting...";
  
      switch (profileStepStatus) {
        case "1":
          navigateTo = "/statutory_v_doc";
          message = "Please complete the statutory documents. Redirecting...";
          break;
        case "2":
          navigateTo = "/licenses_v";
          message = "Please complete the licenses. Redirecting...";
          break;
        case "3":
          navigateTo = "/otherdocs_v";
          message = "Please complete the other documents. Redirecting...";
          break;
        case undefined:
        case null:
          navigateTo = "/createprofile_step_1";
          message = "Please complete the activation process. Redirecting...";
          break;
        default:
          navigate("/dashboard/updates")
      }
  
      if (navigateTo) {
        toast.dismiss(); 
        toast.info(message, { autoClose: 3000 });
  
        setTimeout(() => {
          navigate(navigateTo);
        }, 3000);
      }
    }
  }, [profileData, navigate]);

  const companyData = data?.data || {};

  const statutoryDocuments = statutoryDoc?.data?.statutoryDocuments || {};

  const handleViewPdf = (url) => {
    setIsLoadingPdf(true); // Start loading
    setPdfUrl(url); // Directly set the URL for Viewer
    setShowModal(true);
  };

  useEffect(() => {
    if (pdfUrl) {
      const timer = setTimeout(() => setIsLoadingPdf(false), 1000); // Simulate loading time
      return () => clearTimeout(timer); // Clean up timeout
    }
  }, [pdfUrl]);

  const closeModal = () => {
    setShowModal(false);
    setPdfUrl("");
  };

  return (
    <Fragment>
      <ToastContainer/>
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {isLoadingPdf ? (
              <p>Loading document...</p>
            ) : (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            Close
          </button>
        </div>
      )}

      <div className="type-of-update">
        <div className="wrap">
        <div className="switch">
          <div
            className="per-info"
            onClick={() => {
              setActiveSection("profile_v");
              navigate("/dashboard/profile_v");
            }}
            style={activeSection === "profile_v" ? activeStyle : {}}
          >
            <h3>Personal Info</h3>
            <p>Manage personal details</p>
          </div>
          <div
            className="document"
            onClick={() => {
              setActiveSection("updates");
              navigate("/dashboard/updates");
            }}
            style={activeSection === "updates" ? activeStyle : {}}
          >
            <h3>Documents</h3>
            <p>Update License and other documents</p>
          </div>

          <div
            className="change-pass"
            onClick={() => {
              setActiveSection("updatevpass");
              navigate("/dashboard/updatevpass");
            }}
            style={activeSection === "updatevpass" ? activeStyle : {}}
          >
            <h3>Password</h3>
            <p>Change and manage password</p>
          </div>
        </div>
        <div className="content">
          {/* Mobile Navigation Tabs */}
          <div className="mobile-tabs">
            <div
              className={`mobile-tab ${activeSection === "profile_v" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("profile_v");
                navigate("/dashboard/profile_v");
              }}
            >
              <h3>Company information</h3>
              <p>Manage company information</p>
            </div>
            <div
              className={`mobile-tab ${activeSection === "updates" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("updates");
                navigate("/dashboard/updates");
              }}
            >
              <h3>Documents</h3>
              <p>Update License and other documents</p>
            </div>
            <div
              className={`mobile-tab ${activeSection === "updatevpass" ? "active" : ""}`}
              onClick={() => {
                setActiveSection("updatevpass");
                navigate("/dashboard/updatevpass");
              }}
            >
              <h3>Password</h3>
              <p>Change and manage password</p>
            </div>
          </div>

          <div className="header">
          </div>
          <div className="switch-line">
            <h3
              onClick={() => {
                setAllDoc(true);
                setAllPendingUpdate(false);
              }}
              style={isAllDocs ? activeSwitchLineStyle : {}}
            >
              {
                profileData?.profileVerifiedAtLeastOnce ? "Approved documents" : " Uploaded documents"
              }
            </h3>
            <h3
              onClick={() => {
                setAllDoc(false);
                setAllPendingUpdate(true);
              }}
              style={isAllPendingUpdate ? activeSwitchLineStyle : {}}
            >
              Pending Approvals
            </h3>
            <h3>Approved</h3>   
          </div>
          <div className="wrapper">
            {isAllDocs && (
              <div className="card">
                <div className="sta">
                  <span>
                    <h3>Statutory Documents</h3>
                    <Link to="/updatestatutorydoc">Update</Link>
                  </span>
                  {staLoading ? (
                    <div className="sta-card">
                      {[...Array(2)].map((_, index) => (
                        <div className="cards" key={index}>
                          <div className="in">
                            <Skeleton circle height={40} width={40} />
                            <div className="size">
                              <Skeleton height={20} width={100} />
                              <Skeleton height={16} width={200} />
                            </div>
                          </div>
                          <div className="mark">
                            <Skeleton height={30} width={60} />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : staError ? (
                    <p>Error: {staError.message}</p>
                  ) : (
                    <div className="sta-card">
                      {Object.keys(statutoryDocuments)
                        .filter((key) => key !== "_id")
                        .map((key) => (
                          <div className="cards" key={key}>
                            <div className="in">
                              <CiFileOn className="file" />
                              <div className="size">
                                <h4>{key.toUpperCase()}</h4>
                                <p>200 KB – 100% Uploaded</p>
                              </div>
                            </div>
                            <div className="mark">
                              <Markicon />
                              <button onClick={() => handleViewPdf(statutoryDocuments[key])}>
                                View
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                <div className="sta">
                  <span>
                    <h3>Licenses</h3>
                    <Link to="/updatelicenses">Update</Link>
                  </span>
                  <ViewOtherLicenses />
                </div>
                <div className="sta">
                  <span>
                    <h3>Other Documents</h3>
                    <Link to="/updateotherdocs">Update</Link>
                  </span>
                  <ViewOtherDocs />
                </div>
              </div>
            )}
            {isAllPendingUpdate && (
              <div className="pending-card">
                {isLoading ? (
                  <>
                    <Skeleton height={60} width={500} />
                    <Skeleton height={60} width={500} />
                    <Skeleton height={60} width={500} />
                  </>
                ) : error ? (
                  <p style={{fontFamily:"Montserrat", fontSize:"16px", fontWeight:"500", color:"#000000"}}>Error: {error.message}</p>
                ) : (
                  <PendingUpdateCard
                    update={companyData}
                    isLoading={isLoading}
                    error={error}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      </div>
    </Fragment>
  );
};

export default UpdatesVesselOwner;

